export default __webpack_public_path__ + "static/media/requisitos_para_adopcion.3981946c.pdf";